import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MessageCircle } from "lucide-react";
import { useSettings, buildWaLink } from "../context/SettingsContext";

const igUrl = (h) => (h ? (h.startsWith("http") ? h : `https://instagram.com/${h.replace(/^@/, "")}`) : "#");
const fbUrl = (h) => (h ? (h.startsWith("http") ? h : `https://facebook.com/${h}`) : "#");

export const Footer = () => {
  const { settings } = useSettings();
  const c = settings?.contacts || {};
  return (
  <footer data-testid="footer" className="relative bg-foreground text-white mt-24 rounded-t-[3rem] overflow-hidden">
    <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 grid gap-12 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="mb-4">
          <img src="/logo3duo.png" alt="3Duo" className="h-14 w-auto" />
        </div>
        <p className="font-semibold text-lg mb-3">Tu imaginas. Nós imprimimos.</p>
        <p className="text-white/60 max-w-sm leading-relaxed">
          Criatividade impressa em 3D. Bonecos articulados, decoração, gadgets e presentes únicos, feitos com amor camada a camada.
        </p>
      </div>

      <div>
        <h4 className="font-display font-bold mb-4">Navegação</h4>
        <ul className="space-y-2 text-white/60">
          <li><Link to="/" className="hover:text-secondary transition-colors">Início</Link></li>
          <li><Link to="/produtos" className="hover:text-secondary transition-colors">Produtos</Link></li>
          <li><Link to="/novidades" className="hover:text-secondary transition-colors">Novidades</Link></li>
          <li><Link to="/sobre" className="hover:text-secondary transition-colors">Sobre Nós</Link></li>
          <li><Link to="/contactos" className="hover:text-secondary transition-colors">Contactos</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-display font-bold mb-4">Segue-nos</h4>
        <div className="flex gap-3">
          <a href={buildWaLink(c)} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="grid place-items-center w-11 h-11 rounded-full bg-white/10 hover:bg-secondary hover:text-foreground transition-colors"><MessageCircle size={19} /></a>
          <a href={igUrl(c.instagram)} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="grid place-items-center w-11 h-11 rounded-full bg-white/10 hover:bg-secondary hover:text-foreground transition-colors"><Instagram size={19} /></a>
          <a href={fbUrl(c.facebook)} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="grid place-items-center w-11 h-11 rounded-full bg-white/10 hover:bg-secondary hover:text-foreground transition-colors"><Facebook size={19} /></a>
          <a href={`mailto:${c.email || ""}`} data-testid="footer-email" className="grid place-items-center w-11 h-11 rounded-full bg-white/10 hover:bg-secondary hover:text-foreground transition-colors"><Mail size={19} /></a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-white/40 text-sm">
      © {new Date().getFullYear()} 3Duo — Todos os direitos reservados.
    </div>
  </footer>
  );
};
